import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../sections/Header";
import Hero from "../sections/Hero";
import Manifesto from "../sections/Manifesto";
import Story from "../sections/Story";
import Capabilities from "../sections/Capabilities";
import PrintShop from "../sections/PrintShop";
import FeaturedShow from "../sections/FeaturedShow";
import Work from "../sections/Work";
import MaterialsStrip from "../sections/MaterialsStrip";
import Process from "../sections/Process";
import SoCal from "../sections/SoCal";
import FinalCTA from "../sections/FinalCTA";
import Footer from "../sections/Footer";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView();
    }
  }, [hash]);

  return (
    <div className="relative bg-ink text-paper">
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <Story />
        <Capabilities />
        <PrintShop />
        <FeaturedShow />
        <Work />
        <MaterialsStrip />
        <Process />
        <SoCal />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
